/**
 * Google Analytics Configuration
 * 
 * GA4 Measurement IDs:
 * - Staging: G-S7VGSMV1Y9 (Gantty Staging stream)
 * - Production: G-T34ELZFZ2Y (Gantty Prod stream)
 * 
 * Change the 'environment' field below to select which environment to use:
 * - 'localhost' - Disables tracking (for local development)
 * - 'staging' - Uses staging GA4 stream
 * - 'production' - Uses production GA4 stream
 */

/**
 * Detect environment from hostname or process.env
 * Priority: process.env.ENVIRONMENT > hostname detection > 'localhost'
 */
function detectEnvironment() {
  // For Node.js (Firebase Functions), check process.env first
  if (typeof process !== 'undefined' && process.env && process.env.ENVIRONMENT) {
    return process.env.ENVIRONMENT;
  }
  
  // For browser, detect from hostname
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    
    // Check for production domain
    if (hostname === 'ganttyapp.com' || hostname === 'www.ganttyapp.com' || hostname.endsWith('.ganttyapp.com')) {
      // Check if it's staging subdomain
      if (hostname.startsWith('staging.') || hostname.includes('staging')) {
        return 'staging';
      }
      return 'production';
    }
    
    // Check for Firebase hosting domains
    if (hostname.includes('gantty-app.web.app') || hostname.includes('ganttyapp.web.app')) {
      return 'production';
    }
    if (hostname.includes('gantty-staging.web.app') || hostname.includes('staging.ganttyapp.com')) {
      return 'staging';
    }
    
    // Default to localhost for local development
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0') {
      return 'localhost';
    }
  }
  
  // Default fallback
  return 'localhost';
}

const environment = detectEnvironment();

// Google Analytics configuration
const config = {
  // Environment selection: 'localhost', 'staging', or 'production'
  environment,
  
  // GA4 Measurement IDs for each environment
  measurementId: 
    environment === 'localhost' 
      ? null 
      : environment === 'staging'
      ? 'G-S7VGSMV1Y9'  // Gantty Staging stream
      : 'G-T34ELZFZ2Y',  // Gantty Prod stream
};

// Export the config
export default config;

export { config };

